import axios from '@/util/basehttp';
import qs from 'qs';
const pre = "/sys/menu"
const sysMemu = {
  // post提交
  treeDataList() {
    return axios.get(pre + `/treeData`);
  },
  firstLeveMenu() {
    return axios.post(pre + `/firstLeveMenu`);
  },
  info(menuId) {
    return axios.get(pre + `/info`, {params: {id: menuId}});
  },
  save(params) {
    return axios.post(pre + `/save`, qs.stringify(params));
  },
  delMenu(menuId) {
    return axios.delete(pre + `/delMenu`, {params: {id: menuId}});
  },
  updateStatus(menuId, checked) {
    return axios.post(pre + `/updateStatus`, qs.stringify({id: menuId, checked: checked}));
  },
  // post提交
  ztreeAuthorityData(roleId) {
    return axios.post(pre + `/ztreeAuthorityData`, qs.stringify({roleId: roleId}));
  }
}
export default sysMemu;



// WEBPACK FOOTER //
// ./src/api/sys/menu.js